import { render, staticRenderFns } from "./SponsoredRecommendationImage.vue?vue&type=template&id=41195a34&scoped=true"
import script from "./SponsoredRecommendationImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImage.vue?vue&type=style&index=0&id=41195a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41195a34",
  null
  
)

export default component.exports